import {
  takeLatest,
  takeEvery,
  fork,
  put,
  cancelled,
  all,
} from 'redux-saga/effects'

import { toast } from 'react-toastify'

// We'll use this function to redirect to different routes based on cases
import { history } from '../../helpers'

// Our login constants
import {
  CHECK_AUTHENTICATED,
  LOGIN_REQUESTING,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGOUT,
  LOGOUT_NO_REDIRECT,
} from './constants'

// So that we can modify our User piece of state
import {
  // showLoading,
  // hideLoading,
  setAuthenticated,
  unsetAuthenticated,
  searchEventListSearch,
  searchEventListAllStatus,
  searchEventListAllEventType,
  searchEventListSealStatus,
  searchEventListAllAward,
  searchEventListAllUser,
  unsetUser,
} from '../actions'

import { store } from '../index'

import { ROUTE_PATH, localStorageService } from '../../helpers'

function logout() {
  // localStorage.clear()
  store.dispatch(unsetUser())
  // store.dispatch(searchEventListSearch())
  // store.dispatch(searchEventListAllStatus())
  // store.dispatch(searchEventListAllEventType())
  // store.dispatch(searchEventListSealStatus())
  // store.dispatch(searchEventListAllAward())
  // store.dispatch(searchEventListAllUser())
  history.replace(ROUTE_PATH.LOGIN.LINK)
}

function logout_no_redirect() {
  localStorage.clear()
  store.dispatch(unsetUser())
}

function* loginFlow(email, res) {
  // yield put(showLoading())

  try {
    if (res) {
      if (res.status === 'InActivate') {
        history.push(ROUTE_PATH.CONTACT_ADMIN.LINK)
      } else if (res.status === 'NotActivate') {
        toast.error(
          'Your account has not activated. Please click "Forgot password" to activate.'
        )
      } else {
        const { id, full_name } = res
        const storageService = localStorageService.getService()
        storageService.setUsersName(full_name)
        localStorage.setItem('email', email)
        localStorageService.setCompanyId(res.company_id)
        localStorageService.setBuyerId(id)
        const userData = JSON.stringify(res.roles)
        if (typeof userData !== 'undefined' && userData !== 'undefined') {
          localStorage.setItem('userData', userData)
        } else {
          const roleSupAdmin = [{ id: 5, name: 'SupplierAdmin' }]
          const userData = JSON.stringify(roleSupAdmin)
          localStorage.setItem('userData', userData)
        }
        storageService.setToken(res)
        sessionStorage.setItem('email', email)
        localStorage.setItem('role', res.role)

        if (res.company) {
          localStorage.setItem('logo', res.company.logo)
        }

        yield put(setAuthenticated())
        // redirect them to WIDGETS!
        const itemSupManagement = localStorageService.getSupplierManagement()
        const idProject = localStorage.getItem('idProject')
        const rfqid = localStorage.getItem('rfqid')
        const eventType = localStorage.getItem('eventType')

        const itemSourcingCompare = localStorageService.getSourcingCompare()
        const itemSourcingDetail = localStorageService.getSourcingDetail()
        const tokenCheck = localStorageService.getTokenCheckFromEmail()
        if (itemSupManagement) {
          const url = `/supplier-management-information-edit:${itemSupManagement}`
          history.replace(url)
        } else if (idProject && rfqid) {
          const url = `sourcing-compare-events/${idProject}/${rfqid}/${eventType}`
          history.replace(url)
        } else if (itemSourcingDetail) {
          let url
          if (tokenCheck) {
            url = `/sourcing-detail-form-supplier/${itemSourcingDetail}?token=${tokenCheck}`
          } else {
            url = `/sourcing-detail-form-supplier/${itemSourcingDetail}`
          }
          history.replace(url)
        } else {
          history.replace(ROUTE_PATH.HOME.LINK)
        }
      }
      // .. also inform redux that our login was successful
      yield all([
        put({
          type: LOGIN_SUCCESS,
          payload: {
            email: res.email,
            logo: res.company.logo,
          },
        }),
      ])
    }
  } catch (error) {
    // if (error && error.response) {
    //   const errorStatus = error.response.data.status
    //   const errorMessage = error.response.data.message
    //   // if (errorStatus === 'TooManyAttempts') {
    //   //   // toast.error(errorMessage)
    //   // }
    //   toast.error(errorMessage)
    // }
    yield put({ type: LOGIN_ERROR, error })
  } finally {
    // No matter what, if our `forked` `task` was cancelled
    // we will then just redirect them to login
    if (yield cancelled()) {
      history.push(ROUTE_PATH.LOGIN.LINK)
    }
    // yield put(hideLoading())
  }
}

function* loginWorker({ payload: { email, res } }) {
  yield fork(loginFlow, email, res)
  // yield take(LOGOUT)
  // yield cancel(task)
}

function checkAuthWorker() {
  const storageService = localStorageService.getService()
  if (storageService.getAccessToken() && storageService.getRefreshToken()) {
    store.dispatch(setAuthenticated())
  }
}

// Our watcher (saga).  It will watch for many things.
function* loginWatcher() {
  yield all([
    takeEvery(CHECK_AUTHENTICATED, checkAuthWorker),
    takeLatest(LOGIN_REQUESTING, loginWorker),
    takeEvery(LOGOUT, logout),
    takeEvery(LOGOUT_NO_REDIRECT, logout_no_redirect),
  ])
}

export default loginWatcher
